import { makeStyles } from '@mui/styles';

const muiStyles = makeStyles(() => ({
    root: { backgroundColor: '#FFFFFF' },
    accordionContainer: { boxShadow: 'none' },
    accordionSummary: {
        height: '7rem',
        margin: '-20px 0px !important',
        // minHeight: '42px !important',
        padding: '10px 10px 4px 10px'
    },
    verticalDivider: {
        height: '35px',
        width: '0.5px',
        margin: '0 10px'
    },
    currencyCode: {
        minWidth: '90px',
        fontSize: '2rem',
        fontWeight: 500
    },
    summaryHeader: {
        fontSize: '0.75rem',
        fontWeight: 500,
        color: '#3C4F70'
    },
    summaryContent: {
        fontSize: '1.25rem',
        fontWeight: 500
    },
    detailsContainer: { padding: '0' },
    headerDivider: { maxWidth: '90%' },
    details: {
        width: '100%',
        padding: '9px 12px 12px 12px',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '24px'
    },
    detailsBox: {
        width: '100%',
        height: 'fit-content' as const,
        marginTop: '16px',
        marginLeft: '24px',
        '&:last-child': { marginBottom: '24px' }
    },
    detailsHeader: {
        fontSize: '32px',
        marginLeft: '24px'
    },
    detailsTitle: {
        fontSize: '0.75rem',
        fontWeight: 700,
        color: '#3C4F70'
    },
    transactionTitle: { width: '89px' },
    detailsValue: {
        paddingRight: '20px',
        fontSize: '1.125rem',
        fontWeight: 500
    },
    detailsEquivalent: {
        fontSize: '12px',
        fontWeight: 700
    },
    transactionsBox: {
        display: 'flex' as const,
        alignItems: 'center' as const,
        justifyContent: 'center' as const,
        width: '36px',
        height: '36px',
        borderRadius: '4px',
        fontSize: '1rem',
        fontWeight: 500
    },
    bgBlue: {
        backgroundColor: '#3C4F70',
        color: '#FFF'
    },
    bgLightBlue: {
        backgroundColor: '#89C4F2',
        color: '#000'
    },
    navPrice: { fontSize: '12px' }
}));

export default muiStyles;